import { Link } from 'react-router-dom';

interface Props {
  jobId: string;
  isAdmin: boolean;
  isAddShipment: boolean;
}

export default function JobsTableRowLink({
  jobId,
  isAdmin,
  isAddShipment,
}: Props){
    const adminUrl = isAdmin ? 'admin/' : '';
    const page = isAddShipment ? 'manual-shipments' : 'job-history/view';

    return (
      <Link
        className='text-decoration-none'
        to={`/app/${adminUrl}${page}?job_id=${jobId}`}
      >
        <u
          className='labelText'
          style={{ color: '#251163', fontSize: '16px' }}
        >
          {`${isAddShipment ? 'Select' : 'Details'}`}
        </u>
      </Link>
    );
  }
